import { SVGProps } from '@components/Icon/types';

export const Delete = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      d="M9.76807 10.3282C9.44605 10.3282 9.18591 10.5883 9.18591 10.9103V18.3035C9.18591 18.6255 9.44605 18.8856 9.76807 18.8856C10.0901 18.8856 10.3502 18.6255 10.3502 18.3035V10.9103C10.3502 10.5883 10.0901 10.3282 9.76807 10.3282Z"
      fill={fill}
    />
    <path
      d="M14.2682 10.3282C13.9462 10.3282 13.6861 10.5883 13.6861 10.9103V18.3035C13.6861 18.6255 13.9462 18.8856 14.2682 18.8856C14.5903 18.8856 14.8504 18.6255 14.8504 18.3035V10.9103C14.8504 10.5883 14.5903 10.3282 14.2682 10.3282Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1667 1.90002C9.31611 1.90002 8.62661 2.58953 8.62661 3.44008C8.62661 3.59993 8.651 3.75423 8.69629 3.89938H5.58935C4.38176 3.89938 3.39999 4.88115 3.39999 6.08874C3.39999 7.09498 4.08154 7.94412 5.00719 8.19957V18.3035C5.00719 20.3966 6.7106 22.1 8.80375 22.1H15.2326C17.3257 22.1 19.0291 20.3966 19.0291 18.3035V8.19787C19.9534 7.94216 20.6363 7.09551 20.6363 6.08874C20.6363 4.88115 19.6545 3.89938 18.447 3.89938H15.34C15.3853 3.75423 15.4097 3.59993 15.4097 3.44008C15.4097 2.58953 14.7202 1.90002 13.8696 1.90002H10.1667ZM9.73178 3.44008C9.73178 3.1999 9.92648 3.0052 10.1667 3.0052H13.8696C14.1098 3.0052 14.3045 3.1999 14.3045 3.44008C14.3045 3.68025 14.1098 3.87495 13.8696 3.87495H10.1667C9.92648 3.87495 9.73178 3.68025 9.73178 3.44008ZM4.56431 6.08874C4.56431 5.52359 5.0242 5.0637 5.58935 5.0637H18.447C19.0121 5.0637 19.472 5.52359 19.472 6.08874C19.472 6.65389 19.0121 7.11378 18.447 7.11378H5.58935C5.0242 7.11378 4.56431 6.65389 4.56431 6.08874ZM6.17151 18.3035V8.2781H17.8648V18.3035C17.8648 19.7542 16.6833 20.9357 15.2326 20.9357H8.80375C7.35304 20.9357 6.17151 19.7542 6.17151 18.3035Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'delete';
